<script>
	import { api } from "./../libs/api.js";
	import { _ } from 'svelte-i18n';

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";

	let trails = api.get_all_trails()
	let search = "";
	let country = "";


	$: filtered_trails = trails.then(t => t.data.filter(
		trail => (country == "" || trail.country == country) &&
				(search == "" || trail.title.toLowerCase().includes(search.toLowerCase()))
	))
</script>

<BaseLayer --bg-overlay="url(/assets/bg/mountains.svg)">
	<div class="px-4 pt-4 bg-base-100">
		<input type="text" placeholder="Search" bind:value={search} class="input input-bordered input-sm bg-gray-50 w-full" />
	</div>

	<div class="p-4 bg-base-100 shadow-md flex flex-row">
		<select bind:value={country} class="select select-bordered select-xs w-1/3 mr-4">
			<option selected value="">{$_('trails.all_countries')}</option>
			<option value="it">🇮🇹️ {$_('trails.italy')}</option>
			<option value="hr">🇭🇷️ {$_('trails.croatia')}</option>
			<option value="gr">🇬🇷️ {$_('trails.greece')}</option>
		</select>

		<!--select class="select select-bordered select-xs w-1/4">
			<option disabled selected>Radius</option>
			<option>5km</option>
			<option>15km</option>
			<option>50km</option>
			<option>100km</option>
		</select-->
	</div>

	<div class="px-4 pt-4">
		<h3 class='page-title mt-3 mb-2'>{$_('trails.available')}</h3>

		{#await filtered_trails then value}
		{#each value as trail}
			<div class="card card-compact mb-4 w-full bg-base-100 shadow-xl">
				<figure>
					<img class="w-full h-36 object-cover" src="{api.base_url}/assets/{trail.cover_image}" alt="{trail.title}" />
				</figure>
				<div class="card-body flex-row justify-between">
					<h2 class="card-title">{trail.title}</h2>

					<div class="card-actions justify-end">
						<Link to="trails/{trail.id}">
							<svg class="w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520"><path class="fill-accent" d="M512 256c0-141.4-114.6-256-256-256S0 114.6 0 256c0 141.4 114.6 256 256 256S512 397.4 512 256zM265.9 382.8C259.9 380.3 256 374.5 256 368v-64H160c-17.67 0-32-14.33-32-32v-32c0-17.67 14.33-32 32-32h96v-64c0-6.469 3.891-12.31 9.875-14.78c5.984-2.484 12.86-1.109 17.44 3.469l112 112c6.248 6.248 6.248 16.38 0 22.62l-112 112C278.7 383.9 271.9 385.3 265.9 382.8z"/></svg>
						</Link>
					</div>
				</div>
			</div>
		{:else}
			<h4 class='page-title mt-3 mb-2'>{$_('trails.none')}</h4>
		{/each}
		{/await}
	</div>
</BaseLayer>

